module.exports = __webpack_public_path__ + "static/media/frame.4c8ac93b.svg";